import { render, staticRenderFns } from "./vphTabs.vue?vue&type=template&id=1563b8be&scoped=true&"
import script from "./vphTabs.vue?vue&type=script&lang=js&"
export * from "./vphTabs.vue?vue&type=script&lang=js&"
import style0 from "./vphTabs.vue?vue&type=style&index=0&id=1563b8be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563b8be",
  null
  
)

export default component.exports